// Core data structures for algorithms

export interface Chromosome {
  x: number[];        // Service selection array (gene) - x[i] = service index for task i
  fitness: number;    // Fitness value (solution quality)
  rwp: number;        // Relative weight probability (for selection)
}

export interface Particle {
  position: number[];              // Current position (service selection)
  velocity: number[];              // Velocity vector
  personalBest: number[];          // Personal best position
  fitness: number;                 // Current fitness value
  personalBestFitness: number;     // Personal best fitness
  rwp: number;                     // Relative weight probability (for GA operations)
}

export interface QualityMatrix {
  task: number;        // Task identifier (0-indexed)
  webService: number;  // Web service identifier (0-indexed)
  property: number;    // Quality property index (0-8)
  value: number;       // Quality value
}

export interface QWSService {
  responseTime: number;    // Minimize
  availability: number;    // Maximize
  throughput: number;      // Maximize
  successability: number;  // Maximize
  reliability: number;     // Maximize
  compliance: number;      // Maximize
  bestPractices: number;   // Maximize
  latency: number;         // Minimize
  documentation: number;   // Maximize
  serviceName: string;
  wsdlUrl: string;
}

// QoS Property indices
export enum QoSProperty {
  ResponseTime = 0,
  Availability = 1,
  Throughput = 2,
  Successability = 3,
  Reliability = 4,
  Compliance = 5,
  BestPractices = 6,
  Latency = 7,
  Documentation = 8,
}

// Property weights (all equal weight)
export const QoS_WEIGHTS = [1, 1, 1, 1, 1, 1, 1, 1, 1];

// Property optimization direction: true = maximize, false = minimize
export const QoS_MAXIMIZE = [
  false, // ResponseTime - minimize
  true,  // Availability - maximize
  true,  // Throughput - maximize
  true,  // Successability - maximize
  true,  // Reliability - maximize
  true,  // Compliance - maximize
  true,  // BestPractices - maximize
  false, // Latency - minimize
  true,  // Documentation - maximize
];

